const NotificationGetter = {
  emails: (state) => state.emails,
  sms: (state) => state.sms,
  ads: (state) => state.ads
};

export default NotificationGetter;
